<template>
  <div>
    <generic-modal :id="modalNames.SOME_ID" body="Some body" />
    <edit-org-modal title="Create Organization" />
    <warning-modal title="Disable User" ok-button-text="Disable user" content="Are you sure you want to disable the user April O’neill of Hands that Heal. Doing so will prevent them from logging into the system, and their list will be disabled." />
    <duplicate-modal
      title="Potential duplicated name"
      :is-footer="true"
      ok-button-text="Mark resolved"
      content="Your submission may be a duplicate also registered with another organization. Please reach out to the contact or the organization below to confirm duplication and decide which organization will delete their duplicate."
    />
    <organization-duplicate-modal
      title="Duplicate Contact"
      content="Your submission may be a duplicate also registered with another organization. Please reach out to the contact or the organization below to confirm duplication and decide which organization will delete their duplicate."
    />
    <create-user-modal />
    <duplicate-warning-modal />
    <disable-org-confirmation-modal />
    <disable-user-confirmation-modal />
    <delete-recip-confirmation-modal />
    <delete-user-confirmation-modal />
  </div>
</template>

<script>
import modalNames from '../../util/modalNames';
import GenericModal from './GenericModal';
import EditOrgModal from './EditOrgModal';
import WarningModal from './WarningModal';
import DuplicateModal from './DuplicateModal';
import OrganizationDuplicateModal from './OrganizationDuplicateModal';
import DuplicateWarningModal from './DuplicateWarningModal';
import CreateUserModal from './CreateUserModal';
import DisableOrgConfirmationModal from './DisableOrgConfirmationModal';
import DisableUserConfirmationModal from './DisableUserConfirmationModal';
import DeleteRecipConfirmationModal from './DeleteRecipConfirmationModal';
import DeleteUserConfirmationModal from './DeleteUserConfirmationModal';

export default {
  name: 'Modals',
  components: { GenericModal, EditOrgModal, WarningModal, DuplicateModal, OrganizationDuplicateModal, DuplicateWarningModal, CreateUserModal, DisableOrgConfirmationModal, DisableUserConfirmationModal, DeleteRecipConfirmationModal, DeleteUserConfirmationModal },
  data() {
    return {
      modalNames: { ...modalNames }
    }
  },
}
</script>
